import * as stylex from '@stylexjs/stylex';
import { ChevronRight } from 'lucide-react';
import Link from 'next/link';
import '../../styles/tokens.stylex';
import { spacing } from '../../styles/tokens.stylex';
import { Button } from '../Buttons';
import { Crumb } from './serverUtils';
import { sendGTMEvent } from '@next/third-parties/google';
import { NextLinkWithEventPayload } from '../NextLinkWithEventPayload';
interface BreadcrumbsProps {
  breadcrumbs: Crumb[];
  styles?: stylex.StyleXStyles;
}
export function Breadcrumbs({
  breadcrumbs,
  styles
}: BreadcrumbsProps) {
  return <nav {...stylex.props(sx.navWrapper, styles)} aria-label="Breadcrumb">
      {breadcrumbs.map((crumb, i) => <span key={crumb.url.replace('/', '-')} className="x78zum5 x6s0dn4 xuxw1ft">
          {i > 0 && <ChevronRight className="x15vhz18 xlzyvqe x2lah0s" />}
          <Button variant="ghost" size="extra-compact" theme="neutral" asChild outdentLeftPadding={i === 0} aria-current={crumb.isCurrentPage ? 'page' : undefined} styles={sx.buttonStyles}>
            <NextLinkWithEventPayload href={'/' + crumb.url} clickEventPayload={{
          event: 'navigation_link_click',
          location: 'breadcrumbs',
          href: '/' + crumb.url
        }}>
              {crumb.name}
            </NextLinkWithEventPayload>
          </Button>
        </span>)}
    </nav>;
}
const sx = {
  navWrapper: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kayTVb: "x1clqncf",
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  buttonStyles: {
    k7Eaqz: "x1pshirs",
    khDVqt: "xeaf4i8",
    $$css: true
  }
};